function TermsOfService({ onBackClick }) {
    try {
        React.useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

        const handleBackClick = (e) => {
            e.preventDefault();
            if (onBackClick) onBackClick();
        };

        return (
            <section data-name="terms-of-service" className="bg-gray-900 text-white min-h-screen">
                <div className="container mx-auto px-4 py-16">
                    <button 
                        onClick={handleBackClick}
                        className="mb-8 flex items-center text-green-400 hover:text-green-300 transition-colors"
                        data-name="back-button"
                    >
                        <i className="fas fa-arrow-left mr-2"></i> Back
                    </button>

                    <div className="max-w-4xl mx-auto">
                        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
                        
                        <div className="prose prose-lg prose-invert">
                            <p className="text-gray-300 mb-6">
                                Last updated: {new Date().toLocaleDateString()}
                            </p>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">1. Agreement to Terms</h2>
                            <p className="text-gray-300 mb-6">
                                These Terms of Service constitute a legally binding agreement made between you and Sustainable Compute Network, 
                                concerning your access to and use of the website as well as any other media form, media channel, mobile website 
                                or mobile application related, linked, or otherwise connected thereto. You agree that by accessing the website, 
                                you have read, understood, and agree to be bound by all of these Terms of Service. If you do not agree with all 
                                of these terms, then you are expressly prohibited from using the website and you must discontinue use immediately.
                            </p>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">2. Intellectual Property Rights</h2>
                            <p className="text-gray-300 mb-4">
                                Unless otherwise indicated, the website is our proprietary property and all source code, databases, functionality, 
                                software, website designs, audio, video, text, photographs, and graphics on the website (collectively, the "Content") 
                                and the trademarks, service marks, and logos contained therein (the "Marks") are owned or controlled by us or licensed 
                                to us, and are protected by copyright and trademark laws and various other intellectual property rights.
                            </p>
                            <p className="text-gray-300 mb-6">
                                The Content and the Marks are provided on the website "AS IS" for your information and personal use only. Except as 
                                expressly provided in these Terms of Service, no part of the website and no Content or Marks may be copied, reproduced, 
                                aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, 
                                licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.
                            </p>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">3. User Representations</h2>
                            <p className="text-gray-300 mb-4">
                                By using the website, you represent and warrant that:
                            </p>
                            <ol className="list-decimal list-inside text-gray-300 mb-6 space-y-2">
                                <li>All registration information you submit will be true, accurate, current, and complete;</li>
                                <li>You will maintain the accuracy of such information and promptly update such registration information as necessary;</li>
                                <li>You have the legal capacity and you agree to comply with these Terms of Service;</li>
                                <li>You are not a minor in the jurisdiction in which you reside;</li>
                                <li>You will not access the website through automated or non-human means, whether through a bot, script or otherwise;</li>
                                <li>You will not use the website for any illegal or unauthorized purpose;</li>
                                <li>Your use of the website will not violate any applicable law or regulation.</li>
                            </ol>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">4. User Registration</h2>
                            <p className="text-gray-300 mb-6">
                                You may be required to register with the website. You agree to keep your password confidential and will be responsible 
                                for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if 
                                we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.
                            </p>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">5. Prohibited Activities</h2>
                            <p className="text-gray-300 mb-4">
                                You may not access or use the website for any purpose other than that for which we make the website available. The 
                                website may not be used in connection with any commercial endeavors except those that are specifically endorsed or 
                                approved by us.
                            </p>
                            <p className="text-gray-300 mb-6">
                                As a user of the website, you agree not to:
                            </p>
                            <ul className="list-disc list-inside text-gray-300 mb-6 space-y-2">
                                <li>Systematically retrieve data or other content from the website to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                                <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.</li>
                                <li>Circumvent, disable, or otherwise interfere with security-related features of the website.</li>
                                <li>Disparage, tarnish, or otherwise harm, in our opinion, us and/or the website.</li>
                                <li>Use any information obtained from the website in order to harass, abuse, or harm another person.</li>
                                <li>Make improper use of our support services or submit false reports of abuse or misconduct.</li>
                                <li>Use the website in a manner inconsistent with any applicable laws or regulations.</li>
                                <li>Engage in unauthorized framing of or linking to the website.</li>
                                <li>Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming, that interferes with any party's uninterrupted use and enjoyment of the website or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the website.</li>
                            </ul>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">6. Limitation of Liability</h2>
                            <p className="text-gray-300 mb-6">
                                In no event will we or our directors, employees, or agents be liable to you or any third party for any direct, 
                                indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profit, lost revenue, 
                                loss of data, or other damages arising from your use of the website, even if we have been advised of the possibility 
                                of such damages.
                            </p>

                            <h2 className="text-2xl font-semibold mb-4 text-green-400">7. Contact Us</h2>
                            <p className="text-gray-300 mb-6">
                                In order to resolve a complaint regarding the website or to receive further information regarding use of the website, 
                                please contact us at:<br/>
                                <strong className="text-white">sustainablecomputenetwork@activist.com</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    } catch (error) {
        console.error('TermsOfService error:', error);
        reportError(error);
        return null;
    }
}

window.TermsOfService = TermsOfService;

export default TermsOfService;
